import { DialogContent, DialogContentText } from "@mui/material";
import moment from "moment";
import React from "react";

const DialogUserContent = ({ selectedUser }) => {
    return (
        <>
            <DialogContent>
                <DialogContentText>
                    <strong>Nombre:</strong> {selectedUser.first_name} {selectedUser.last_name}
                </DialogContentText>
                <DialogContentText>
                    <strong>Email:</strong> {selectedUser.email}
                </DialogContentText>
                <DialogContentText>
                    <strong>DNI:</strong> {selectedUser.dni}
                </DialogContentText>
                <DialogContentText>
                    <strong>Fecha de cumpleaños:</strong>{" "}
                    {moment(selectedUser.birthday).format("DD/MM/YYYY")}
                </DialogContentText>
                {selectedUser.role && (
                    <DialogContentText>
                        <strong>Rol:</strong> {selectedUser?.role}
                    </DialogContentText>
                )}
            </DialogContent>
        </>
    );
};

export default DialogUserContent;
